import {
  Box,
  Collapse,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../../api/api';
import TeamMemberTimeCard from '../project-info-cards/TeamMemberTimeCard';
import ExoForm from '../../../components/exo/ExoForm';
import TodayIcon from '@mui/icons-material/Today';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import ExoDialog from '../../../components/exo/ExoDialog';
import ExoWorkday from '../../../components/exo/ExoWorkday';
import { ExoTableToolbarItem } from '../../../components/exo/ExoTableToolbar';
import TimeTrackingExportDialog from './TimeTrackingExportDialog';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { renderHours } from '../../time-tracking/worktime';
const TimesTab = ({ project }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const [timesPerUser, setTimesPerUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const config = useConfig();

  // Export dialog state
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [currentDateRange, setCurrentDateRange] = useState({
    dateStart: null,
    dateEnd: null,
  });

  useEffect(() => {
    if (!config) return;
    updateTimes();
  }, [config]);

  function updateTimes(data = {}) {
    // Track current date range for export dialog
    setCurrentDateRange({
      dateStart: data.dateStart || null,
      dateEnd: data.dateEnd || null,
    });

    var string = ``;
    if (data.dateStart && data.dateEnd)
      string += `?startDate=${data.dateStart}&endDate=${data.dateEnd}`;
    // "/${taskGroup.id}"${string}"
    DBRequest({
      config,
      path: `time-trackings/project-times-per-user/${project.id}${string}`,
      method: API_GET,
      onResponse: setTimesPerUser,
      onLoading: setIsLoading,
    });
  }

  const fields = [
    {
      label: t('Timespan'),
      key: 'date',
      type: 'dateRange',
    },
  ];

  const [selectedUser, setSelectedUser] = useState(null);

  const totalTime = (timesPerUser?.data || []).reduce(
    (sum, time) => sum + (Number(time.timeInProject) || 0),
    0
  );

  return (
    <Box className="flex flex-col gap-2 w-full">
      <Box className="flex flex-wrap items-center justify-between gap-2">
        <Box className="flex items-center gap-2">
          <IconButton onClick={() => setOpen(!open)}>
            <TodayIcon />
          </IconButton>
          <ExoTableToolbarItem
            text={t('CSV exportieren')}
            icon={<FileDownloadIcon />}
            onClick={() => setExportDialogOpen(true)}
          />
        </Box>
        {!isLoading && (
          <Tooltip title={t('Total time in project')}>
            <Typography
              variant="h4"
              className="monospace flex items-center gap-2 whitespace-nowrap pr-2"
            >
              <AccessTimeIcon />
              <b>{renderHours(totalTime)} h</b>
            </Typography>
          </Tooltip>
        )}
      </Box>
      <Collapse in={open}>
        <Box
          className="p-2 rounded-lg"
          sx={{
            backgroundColor: colors.card,
          }}
        >
          <ExoForm
            header={t('Time Range')}
            fields={fields}
            onCancel={() => setOpen(false)}
            onSubmit={updateTimes}
          />
        </Box>
      </Collapse>

      {isLoading ? (
        <Box>{t('Loading...')}</Box>
      ) : (
        <>
          {timesPerUser.data.map((time, index) => (
            <TeamMemberTimeCard
              key={index}
              person={time.user}
              time={time.timeInProject}
              onSelect={setSelectedUser}
            />
          ))}
          <TimeDetails
            userId={selectedUser && selectedUser.id}
            projectId={project.id}
            onClose={() => setSelectedUser(null)}
          />
        </>
      )}

      <TimeTrackingExportDialog
        open={exportDialogOpen}
        onClose={() => setExportDialogOpen(false)}
        project={project}
        dateStart={currentDateRange.dateStart}
        dateEnd={currentDateRange.dateEnd}
        teamUsers={timesPerUser?.data?.map((item) => item.user) || []}
      />
    </Box>
  );
};

const TimeDetails = ({ userId, projectId, onClose }) => {
  const config = useConfig();

  const [allTimes, setAllTimes] = useState(null);
  const [daysToRender, setDaysToRender] = useState(null);
  useEffect(() => {
    if (userId)
      DBRequest({
        config,
        path: `timetrackings/timesperday?&allDaysWithTime=1&userId=${userId}&projectId=${projectId}`,
        method: API_GET,
        onResponse: handleResponse,
      });
  }, [userId]);

  function handleResponse(res) {
    setAllTimes(res);
    setDaysToRender(res);
  }

  return (
    <ExoDialog open={Boolean(userId && projectId)} onClose={onClose}>
      {allTimes && (
        <ExoWorkday
          workdays={daysToRender}
          daySpan={14}
          labelFormat={'dddd'}
          onlyDaysWithTime
        />
      )}
    </ExoDialog>
  );
};

export default TimesTab;
